import { useMutation } from '@tanstack/react-query';

import { downloadRezeptFormatPdf, type RezeptFormatPdfPayload } from '@/services/main/rezept';
import { useClinicContext } from './useClinicContext';

/**
 * Mutation — フォーマット印刷: blank receipt template PDF.
 * Per BD: renders 領収書 / 請求書 / 請求書兼領収書 with NO rezept data filled in
 * (so the user can print and write by hand). Caller passes the Print Settings
 * panel values; BE picks templates by `print_receipt` / `print_invoice` /
 * `print_receipt_invoice` flags and renders in fixed order 領収書 → 請求書 → 兼用.
 */
export const useRezeptFormatPdf = () => {
  const { tenant, clinicNumber } = useClinicContext();

  return useMutation({
    mutationFn: (payload: RezeptFormatPdfPayload) =>
      downloadRezeptFormatPdf(tenant ?? '', clinicNumber ?? '', payload),
  });
};
